import { render, staticRenderFns } from "./userpart.vue?vue&type=template&id=6e7bd5b3&"
import script from "./userpart.vue?vue&type=script&lang=js&"
export * from "./userpart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports